/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


/*
 * U9 2段目（2026-10）: 国・通貨セレクターの国の一覧をあとから差し込む。
 * snippets/cross-border.liquid は国の一覧を空のまま出す。ページの読み込み後に
 * sections/api-country-list.liquid（?section_id=api-country-list）を1回だけ取得して、
 * ページ内のすべての国の popout-select に差し込む。
 * テーマの popout-select は選択肢へのイベントを初期化のときに1つずつ付ける作りなので、
 * 差し込んだあとに要素を複製して入れ替え、初期化し直させる。
 * 取得に失敗したときは何もしない（ボタンはそのまま残る）。
 * jQuery に頼らない。下の jQuery の処理より前に置いているのは、jQuery の読み込みが
 * 間に合わないと下の行で処理が止まり、これより後ろが実行されないため。
 */
(function() {
  const LIST_SELECTOR = '.localization-form popout-select.select-popout--country [data-popout-list] .select-popout__list__scroll';
  let listHtml = null;
  let requested = false;

  function fill(container) {
    if (listHtml === null) return;

    const popouts = [];

    container.querySelectorAll(LIST_SELECTOR).forEach((list) => {
      if (list.children.length) return;

      list.innerHTML = listHtml;

      // 国旗を出さない設定の場所（モバイルメニューなど）では国旗を外す
      const form = list.closest('.localization-form');
      if (form && !form.classList.contains('localization-form--country-flag')) {
        list.querySelectorAll('.select-popout__flag').forEach((flag) => flag.remove());
      }

      const popout = list.closest('popout-select');
      if (popout) popouts.push(popout);
    });

    if (!popouts.length) return;

    customElements.whenDefined('popout-select').then(() => {
      popouts.forEach((popout) => {
        if (!popout.isConnected) return;

        // 複製して入れ替えると disconnectedCallback → connectedCallback が呼ばれ、差し込んだ選択肢にもイベントが付く
        popout.replaceWith(popout.cloneNode(true));
      });
    });
  }

  function load() {
    if (requested) return;
    requested = true;

    if (!document.querySelector(LIST_SELECTOR)) return;

    const root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';

    fetch(`${root}?section_id=api-country-list`, {credentials: 'same-origin'})
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const source = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-country-list]');
        if (!source || !source.children.length) return;

        listHtml = source.innerHTML;
        fill(document);
      })
      .catch(() => {
        // 取得に失敗したときは何もしない（国の一覧が空のままボタンが残る）
      });
  }

  // テーマエディタでセクションが描き直されたときも、取得済みの一覧を差し込む
  document.addEventListener('shopify:section:load', (event) => fill(event.target));

  if (document.readyState === 'complete') {
    load();
  } else {
    window.addEventListener('load', load);
  }
})();


(function() {
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
})();
